import { format } from 'date-fns'
import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    charts: null,
    type: null,
    target: null,
    currentDate: null,
    businessDay: null,
    busy: false,
    modalBusy: false,
  },
  modules: {},
  mutations: {
    set(state, data) {
      state.charts = data.charts
      state.type = data.type
      state.target = data.target
      state.currentDate = new Date()
    },
    setBusinessDay(state, businessDay) {
      state.businessDay = businessDay
    },
    busy(state, busy) {
      state.busy = busy
    },
    modalBusy(state, busy) {
      state.modalBusy = busy
    },
    updateTarget(state, target) {
      state.target = { ...state.target, ...target }
    },
    updateType(state, type) {
      state.type = type
    },
  },
  getters: {
    dayChart(state, { chartAnnotation }) {
      if (!state.charts?.targetDay) return null

      const [header, ...columns] = state.charts.targetDay
      return [[...header, chartAnnotation.definitions], ...columns.map(column => [...column, chartAnnotation.value])]
    },
    stackChart(state, { chartAnnotation }) {
      if (!state.charts?.targetStack) return null

      const [header, ...columns] = state.charts.targetStack
      return [[...header, chartAnnotation.definitions], ...columns.map(column => [...column, chartAnnotation.value])]
    },
    weeks() {
      return ['月', '火', '水', '木', '金', '土', '日']
    },
    setting(state) {
      return { type: state.type, target: state.target }
    },
    chartAnnotation(state, getters, rootState, { 'analysis/colors/target': colors }) {
      return {
        definitions: { role: 'style' },
        value: `stroke-color: ${colors[0]}; stroke-width: 1;`,
      }
    },
  },
  actions: {
    async get({ commit, state }) {
      if (state.busy) return
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/analysis/target/get')

      if (status === 200) {
        commit('set', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
    async getBusinessDay({ commit, state }, date = new Date()) {
      if (state.busy) return
      commit('modalBusy', true)

      const { status, message, data } = await POST('/api/web/businessday/list', {
        start_date: format(date, 'YYYYMM'),
      })

      if (status === 200) {
        commit('setBusinessDay', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('modalBusy', false)
    },
    async save({ commit, state }, { type, target }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/analysis/target/regist', { type, target })
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },
    async saveRelease({ commit, state }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/analysis/target/delete')
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },
  },
}
